import { AdminRoleLabels } from "entities/auth/constants";
import { AdminRole } from "entities/auth/types";
import { type FC } from "react";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import StatusChip from "shared/components/StatusChip";

type RoleChipsProps = {
  roles: AdminRole[];
};

const RoleChips: FC<RoleChipsProps> = ({ roles }) => {
  return (
    <FlexCenter gap={"0.5rem"}>
      {roles.map((role) => (
        <StatusChip
          key={role}
          title={AdminRoleLabels[role].label}
          color={AdminRoleLabels[role].color}
        />
      ))}
    </FlexCenter>
  );
};

export default RoleChips;
